import { useQuery } from '@tanstack/react-query';
import { getMIPInvestorDocumentWorkflowListData } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

export const useInvestorDocumentWorkflowList = (investorId: string | undefined) => {
	return useQuery({
		queryKey: [API_PATHS.MIP_INVESTOR_INVESTORID_DOCUMENT_WORKFLOW_GET, { investorId }],
		queryFn: ({ signal }) =>
			getMIPInvestorDocumentWorkflowListData(
				API_PATHS.MIP_INVESTOR_INVESTORID_DOCUMENT_WORKFLOW_GET,
				{ investorId },
				signal
			),
		enabled: !!investorId,
	});
};
